import React, { Component } from 'react';
import withGetArrayData from '../../../HOCs/withGetArrayData';

class SalesOrderTypeDropdown extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const options = this.props.data.map((item) => (
      <option value={item.value} key={item.value}>
        {item.text}
      </option>
    ));
    return (
      <select
        onChange={this.props.onChange}
        style={{ width: '100%' }}
        value={this.props.value}
      >
        <option value="">All Types</option>
        {options}
      </select>
    );
  }
}

export default withGetArrayData(
  SalesOrderTypeDropdown,
  '/SalesOrderType',
  (array) =>
    array.map((item) => {
      return {
        value: item.Name.trim(),
        key: item.SOTID,
        text: item.Name.trim(),
      };
    })
);
